var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-8 lg:mt-20 p-5 lg:p-10 bg-blue-300 rounded-lg border-blue-800 border-4"},[_c('label',[_vm._v(_vm._s(_vm.$t('app.appLaunch')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }